<!-- TEMPLATE -->
<template>
  <div class="dean-widget">
    <div class="dean-widget-container">
      <div class="dean-widget-bar" @click="clickTitle">
        <slot name="title" class="title"></slot>
        <span v-if="button" class="button">
          <slot name="button-text" class="text"></slot>
          <dean-icon
            class="icon"
            :glyph="featherIconArrowRight"
            :height="20"
            :width="20"
          />
        </span>
      </div>
      <span class="dean-widget-content"><slot></slot></span>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

// SVG
import featherIconArrowRight from '../svg/feather-icons/arrow-right.svg';
// COMPONENTS
import deanSectionDivider from './deanSectionDivider.vue';
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanSectionDivider,
    deanIcon
  }
})
export default class deanWidget extends Vue {
  @Prop({ default: false }) button!: boolean;
  featherIconArrowRight: object = featherIconArrowRight;

  // EMIT
  @Emit('title-click') clickTitle() {
    console.log('click');
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN WIDGET
.dean-widget {
  padding: 10px;
}

.dean-widget-container {
  background: white;
  @include border-radius(10px);
  @include box-shadow(3px 3px 5px rgba(0, 0, 0, 0.075));
  border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  min-height: 100%;
  //border: 1px solid var(--color-light, $color-light);
  .dean-widget-content {
    display: block;
    min-height: 100%;
    min-width: 100%;
    padding: 10px;
  }

  .dean-widget-bar {
    @include display-flex;
    align-items: center;
    height: 50px;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    cursor: pointer;
    user-select: none;
    span {
      @include display-flex;
      align-items: center;
      padding: 10px;
      text-align: left;
      font-weight: 500;
      font-size: $font-heading-small;
      @include transition(all 0.5s ease);
      color: var(--color-dark, $color-dark);
      fill: var(--color-link, $color-link);
    }
    &:hover .button .icon,
    &:hover .button span,
    &:hover span {
      fill: var(--color-link-shade-2, $color-link-shade-2);
      color: var(--color-link-shade-2, $color-link-shade-2);
    }
    .button {
      @include display-flex;
      align-items: center;
      span {
        font-weight: 200;
        font-size: $font-medium;
        color: var(--color-link, $color-link);
      }
      .icon {
        @include transition(all 0.5s ease);
        fill: var(--color-link, $color-link);
      }
    }
  }
}
</style>
